/**
 * Vuex mutations for the "restrict" module.
 *
 * Synchronous state writers for reply restriction. Async work (API calls)
 * lives in operations.js, which commits these mutations with the results.
 */
export default {
    /** Replace `state.replies` with an array of booleans, one per reply, indicating whether that reply's id differs from `restrict`. */
    SET_RESTRICT_ON_REPLIES(state, restrict) {
        state.replies = state.replies.map(reply => reply.id !== restrict);
    },
};
